module.exports = __webpack_public_path__ + "img/left-bg.e7e95a09.png";